import { Box } from '@mui/material';
import LazySearchField from '../../../../../../../../../../components/FormInputs/TextField/LazySearchField';
import LangEnum from '../../../../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../../../translation/TranslationContext';
import { usePackStyles } from '../../../styles/usePackStyles';

interface PacksMenuHeaderDesktopProps {
  readMode: boolean;
  onSearch: (query: string) => void;
}

const PacksMenuHeaderDesktop = ({ onSearch, readMode }: PacksMenuHeaderDesktopProps) => {
  const { classes: packStyles } = usePackStyles();

  const { translate } = useTranslation();

  return (
    <Box style={{ overflowX: 'hidden' }}>
      <Box
        className={packStyles.headerContainer}
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: '48px',
          columnGap: '20px',
        }}
      >
        <Box
          sx={{
            position: 'sticky',
            left: '0px',
            borderLeft: '8px solid white',
            width: '167px',
          }}
        >
          {!readMode && (
            <LazySearchField
              onChangeWithDebounce={onSearch}
              placeholder={translate(LangEnum.PACKS_MENU_SEARCH_PACKS_LABEL)}
            />
          )}
        </Box>

        <Box
          sx={{
            width: '71px',
          }}
        />
      </Box>
    </Box>
  );
};

export default PacksMenuHeaderDesktop;
